import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.Preparation.SampledMass`]: wrap([
    `${prefix}.Preparation.TareMass`,
    `${prefix}.Preparation.TarePlusSampledMass`,
  ]),
  [`${prefix}.TestPortions.MoistureDetermination.DryingTray.ConstantDrySoilMass`]: wrap([
    `${prefix}.TestPortions.MoistureDetermination.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
